

export class VueOtherDocumentScreenData {
    
    document: Object;
    loadingApprove: boolean;
    loadingRejected: boolean;
    document_url: string;
    currentStage: number;
    allStages: Array<any>;
    loadingSave: boolean;
    dirty: boolean;
    loadingContinueFlow: boolean;

    constructor(){
        this.document = undefined
        this.loadingApprove = false
        this.loadingRejected = false
        this.document_url = ''
        this.currentStage = undefined
        this.allStages = []
        this.loadingSave = false
        this.dirty = false
        this.loadingContinueFlow = false
    }

    setDocument(value: Object) {
        this.document = value
    }

    setCurrentStage(value: number) {
        this.currentStage = value
    }

    setAllStages(value: Array<Object>) {
        this.allStages = value
    }

    setLoadingAprove(value: boolean) {
        this.loadingApprove = value
    }

    setLoadingRejected(value: boolean) {
        this.loadingRejected = value
    }

    setDocumentUrl(value: string) {
        this.document_url = value
    }

    setLoadingSave(value: boolean) {
        this.loadingSave = value
    }

    setDirty(value: boolean) {
        this.dirty = value
    }

    setLoadingContinue(value: boolean) {
        this.loadingContinueFlow = value
    }
    
}